const addHeroClass = (element, className) => {
  if (element) {
    element.classList.add(className);
  }
};

export const initHeroAnimations = ({ motionEnabled }) => {
  if (!motionEnabled) return;

  const heroes = Array.from(
    document.querySelectorAll(".himml-hero, .himml-hero-2")
  );
  if (heroes.length === 0) return;

  heroes.forEach((hero) => {
    const heroContent = hero.querySelector(".wp-block-media-text__content");
    const heroPill = hero.querySelector(".himml-notice");
    const heroHeadline = heroContent?.querySelector(
      "h1.wp-block-heading, h1, .wp-block-heading"
    );
    const heroVisual = hero.querySelector(".wp-block-media-text__media");

    let heroSubheadline = null;
    let heroCtas = null;
    let heroSocialProof = null;

    if (heroContent) {
      const ctaButton = heroContent.querySelector(".wp-block-buttons");
      if (ctaButton) {
        heroCtas = ctaButton.closest(".wp-block-group");
      }

      const ratingStars = heroContent.querySelector(".himml26-rating-stars");
      if (ratingStars) {
        heroSocialProof = ratingStars.closest(".wp-block-group");
      }

      const headingGroup = heroHeadline?.closest(".wp-block-group");
      if (headingGroup) {
        heroSubheadline = headingGroup.querySelector("p");
      }

      if (!heroSubheadline) {
        heroSubheadline = heroContent.querySelector("p");
      }
    }

    addHeroClass(heroPill, "hero-pill");
    addHeroClass(heroHeadline, "hero-headline");
    addHeroClass(heroSubheadline, "hero-subheadline");
    addHeroClass(heroVisual, "hero-visual");
    addHeroClass(heroCtas, "hero-ctas");
    addHeroClass(heroSocialProof, "hero-social-proof");

    hero.classList.add("hero-animate");
  });
};
